import { ReactNode } from 'react'
import { GridApi } from 'ag-grid-community'
import { CalendarDateVO } from '../../../../domain/value-object/CalendarDateVO'
import {
  AggregateField,
  AggregateTarget,
} from '../../../../domain/entity/WbsItemEntity'
import { GanttDisplayUnit } from '../../../../domain/value-object/GanttParameterVO'
import { ProgressLineOverlay } from '../../../containers/commons/AgGrid/components/cell/custom/gantt/ProgressLineOverlay'
import { GanttRowItem } from '../../../containers/commons/AgGrid/components/cell/custom/gantt/type'
import { ProgramManagementRow } from '../programManagement'

type GanttChartProviderProps = {
  gridApi: GridApi<ProgramManagementRow> | null
  ganttVisible: boolean
  timeScale: CalendarDateVO[]
  aggregateTarget: AggregateTarget
  aggregateField: AggregateField
  unit: GanttDisplayUnit
  getGanttRowItem: (data: ProgramManagementRow) => GanttRowItem | undefined
  children: ReactNode
}

export const GanttChartProvider = ({
  gridApi,
  ganttVisible,
  timeScale,
  aggregateTarget,
  aggregateField,
  unit,
  getGanttRowItem,
  children,
}: GanttChartProviderProps) => {
  return (
    <>
      {children}
      {ganttVisible && gridApi && timeScale.length > 0 && (
        <ProgressLineOverlay
          gridApi={gridApi}
          timeScale={timeScale}
          aggregateTarget={aggregateTarget}
          aggregateField={aggregateField}
          unit={unit}
          getGanttRowItem={getGanttRowItem}
        />
      )}
    </>
  )
}
